import { Accordion, AccordionItem, AccordionTrigger } from 'alm-react-components';
import moment from 'moment-timezone';
import React, { useContext, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PLIVETIME, Week } from '../../assets/constants/constants';
import { AppContext } from '../../context/AppProvider';
import { ProgramWeekDetail } from '../pages/program/ProgramWeekDetail';
import { checkCurrentDate, checkSuperUsers, mainProgramWeekEnable } from '../../lib/utils';

type ProgramInstructionsProps = {
  courseDetails: [];
  isFundamentalProgram: boolean;
  userEnrolmentDate: string | undefined;
  pId: string;
  currentQuarter: any;
  programStart: any;
  programDetailObject: any;
  hidePageLoader:any;
  watchRecordingId:any
};

export const ProgramInstructionsList: React.FC<ProgramInstructionsProps> = ({
  courseDetails,
  isFundamentalProgram,
  userEnrolmentDate,
  pId,
  currentQuarter,
  programStart,
  programDetailObject,
  watchRecordingId,
}) => {
  const [query] = useSearchParams();
  const activeWeekKey: any = query.get('activeWeek');
  const accordianRef = useRef<any>(
    courseDetails.map((week: any) => week.visible ? React.createRef() : null)
  );
  const {state} = useContext(AppContext);

  const showWeekContent = (key: number) => {
    //Set start date of current quater
    const quarterStartDate = currentQuarter.start;

    if (isFundamentalProgram) {

      // const muserEnrolmentDate = moment(`${userEnrolmentDate}`, 'YYYY-MM-DD'); 
      // const mquarterStartDate = moment(`${quarterStartDate}`, 'YYYY-MM-DD'); 
      // const isBefore = muserEnrolmentDate.isBefore(mquarterStartDate);

      // if(isBefore){
      //   // If user is more than 13 weeks ahead of the current quarter,
      //   // show the week 13th
      //   return true;
      // }else{
      //   const flag = mainProgramWeekEnable(dateConvertedtoUTC(`${quarterStartDate} ${PLIVETIME}`), key, state?.user?.timeZoneCode);
      //   return flag;
      // }
      return true
      
    } else {
      let flag:boolean=false;
      const muserEnrolmentDate = moment(`${userEnrolmentDate}`, 'YYYY-MM-DD'); 
      const mquarterStartDate = moment(`${quarterStartDate}`, 'YYYY-MM-DD'); 
      const quarterEnrollmentStartDate = moment(`${mquarterStartDate}`).subtract(Week*2,'days');
      // If enrollment date is before quarter start date or program start date is not provided,
      // show the week 13th starting date 
      
      // check if user is more than 13 weeks ahead of the current quarter, show the week 13th starting date 
      
      // Check if week is enabled for user based on their enrollment date and timezone
      if(muserEnrolmentDate.isBefore(quarterEnrollmentStartDate)){
        flag= true ;
      } else if(!programStart) { // show the week 13th if program qater start date not available
        flag = true;
      }else {
        flag = mainProgramWeekEnable(dateConvertedtoUTC(`${programStart} ${PLIVETIME}`), key);
      }
      return flag;
    }
  };
  const dateConvertedtoUTC = (pStartDate:string) => moment(pStartDate, 'YYYY-MM-DD HH:mm:ss').tz('UTC').format();

  const getWeekStartDate = (courseKey: number) => {
    const days = courseKey * 7;
    const sDate =  moment(new Date(programStart)).utc().toDate() //original API response getDate(programStart);
    const weekStartDate = moment(sDate).add(days, 'days').format('MMMM DD, hh:mm A');
    return weekStartDate;
  };
  useEffect(() => {
    const accordianRefKey = accordianRef?.current[activeWeekKey];
    if (activeWeekKey && accordianRefKey) {
      accordianRef.current[activeWeekKey].scrollIntoView({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [activeWeekKey,courseDetails]);
  let weekNumber = 0;
  return (
    <>
      {currentQuarter  && courseDetails?.filter((week:any)=>week.visible === true).map((week: any, windex: number) => {
          let shouldVisible = false;
          let displayDate = '';
             //Week should visible if user completed program or current week in current date
            if(checkSuperUsers(state?.user?.roles)){
              shouldVisible=true
              displayDate = getWeekStartDate(windex);

            }else if(checkCurrentDate(state?.user?.currentDate)){
              if (isFundamentalProgram) {
                shouldVisible = showWeekContent(weekNumber);
              } else {
                shouldVisible = showWeekContent(weekNumber);
                displayDate = getWeekStartDate(windex);
              }
            }
            weekNumber = weekNumber + 1;
          

          return (
            <Accordion
              key={`program-listing-${weekNumber}`}
              type="single"
              collapsible
              className="w-full instruction-accordion go-to-top"
              defaultValue={`course-item-${activeWeekKey}`}
              ref={el => (accordianRef.current[week.id] = el)}
              >
              <AccordionItem
                  key={`course-items-${week.id}`}
                  value={`course-item-${week.id}`}
                disabled={!shouldVisible}
                className="border-0"
              >
                <AccordionTrigger
                  className={`mb-6 relative px-4 rounded-lg commitment-accordion text-xl font-barlowLight border border-formTextMute py-3 hover:no-underline ${
                    shouldVisible
                      ? 'aria-[expanded=true]:bg-[#181818]  aria-[expanded=false]:bg-[#181818]'
                      : ''
                  } aria-[expanded=true]:mb-10 aria-[expanded=true]: ${
                    shouldVisible ? 'text-primary' : ''
                  }`}
                >
                  <div className="flex w-full text-center justify-start max-md:flex-col max-md:text-left ">
                    {!isFundamentalProgram && displayDate !== '' && (
                      <span className="font-barlowRegular font-normal text-base ml-8 max-sm:ml-[0.5rem] pr-1 relative capitalize">
                        <span className={`w-[8px] h-[8px] rounded-full ${ shouldVisible ? 'bg-activeDotBg':'bg-red-500' } -mx-4  absolute top-[10px]`}></span>
                      </span>
                    )}
                    <span className="uppercase font-normal font-barlowLight w-auto pr-4 text-left max-sm:ml-3">
                      {week?.name}
                    </span>
                  </div>
                </AccordionTrigger>
                {shouldVisible && week?.courseArray?.map((course: any, index: number) => {
                    return (
                        <div
                          className="accordion-content"
                          key={`course-lession-${week.id}-${course.id}`}
                        >
                          <ProgramWeekDetail
                            course={course}
                            index={index}
                            timeZoneCode={state?.user?.timeZoneCode}
                            pId={pId}
                            week={week}
                            wIndex={windex}
                            programDetailObject={programDetailObject}
                            currentQuarter={currentQuarter}
                            watchRecordingId={watchRecordingId}
                          />
                        </div>
                    );
                  })}
              </AccordionItem>
            </Accordion>
          );
        })}
    </>
  );
};
